import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { detectLanguage } from './languages';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Build output contains English markup. Reuse it only when the client also
// selects English; other languages render directly without a hydration mismatch.
if (container.hasChildNodes() && detectLanguage() === 'en') {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
